import { useTranslation } from 'react-i18next';
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import apiRequest from '../../functions/api';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import axios from 'axios';
import { API_BASE_URL } from '../../constants/apiConstants';
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import { Grid, Typography, Button, Table, TableRow, TableBody, TableCell, TableContainer, IconButton } from '@mui/material'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { useMessage } from "../../context/message-context";
import ListIcon from "@mui/icons-material/List";
import AppsIcon from "@mui/icons-material/Apps";
import openFile from "../shared/functions/download";
import { FullPageSpinner } from '../lib';
function TimeAccount(props) {
  const { t } = useTranslation();
  const { client, accessToken, user } = props;
  const [lastJournals, setLastJournals] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const today=new Date()
  const { hideMessage, showErrorMessage } = useMessage();
  const [ansicht, setAnsicht] = useState(0);
  useEffect(() => {
    setIsLoading(true);
    const payload = {
      "mandant": client, // this.props.client,
      "program": (location.pathname === "/PMAST0") ? "PMAST0" : (location.pathname === "/PMAST1") ? "PMAST1" : "PZKDR0",
      "statement": "LETZTE_MONATE",
      "user": user
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, timeAccountCb);
    // eslint-disable-next-line
  }, [])
  const timeAccountCb = (response) => {
    if (response.status === 200) {
      setLastJournals(response.data.timejournals);
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message)
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
      navigate(-1);
    }
  }
  const downloadFile = (key) => {
    console.log('file with key: ', key);
    const payload = {
      "mandant": client,
      "program": (location.pathname === "/PMAST0") ? "PMAST0" : (location.pathname === "/PMAST1") ? "PMAST1" : "PZKDR0",
      "statement": "JOURNAL_LADEN",
      "timeperiod": key,
      "user": user
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
      "Accept": "application/pdf"
    }
    axios.post(API_BASE_URL + 'daten', payload, { headers: headers, responseType: 'blob' })
      .then((response) => {
        console.log(response);
        var fileName = (user) ? 'Zeitjournal_' + key + '_' + user + '.pdf' : 'Zeitjournal_' + key+"_"+today.getDate()+ '.pdf';
        var contentFile = response.data;
        openFile(fileName, contentFile);
        closeModal();
      })
      .catch(function (error) {
        console.log(error);
        closeModal();
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }

  const closeModal = () => {
    setShowModal(false);
  }
  const open = (key) => {
    setShowModal(true);
    downloadFile(key);
  }
  function changeAnsicht(uebergabe) {
    if (uebergabe === 0) {
      setAnsicht(1);
    } else {
      setAnsicht(0);
    }
  }
  if (isLoading) {
    return <LoadingComponent path={props.location} />
  }
  const displayJournalTable = lastJournals.map((dataObject, count) => {
    return (
      <Fragment key={dataObject.key+'f'}>
        {(dataObject.head) &&
          <TableRow  key={dataObject.key+'h'} style={{ backgroundColor: `rgba(${"170"},${"170"},${"170"},0.2)` }}>
            <TableCell colSpan={2} key={dataObject.key+'h1'}>{dataObject.head}</TableCell>
          </TableRow>
        }
        <TableRow style={{ cursor: 'pointer', }} hover key={dataObject.key} onClick={() => open(dataObject.key, count)}>
          <TableCell key={dataObject.key+'c1'}><InsertDriveFileOutlinedIcon color="primary" /></TableCell>
          <TableCell key={dataObject.key+'c2'}>{dataObject.bez}</TableCell>
        </TableRow>
        </Fragment>
    );
  })
  const displayJournalGrid = lastJournals.map((dataObject, count) => {
    const text = dataObject.text;
    const key = dataObject.key;
    return (
      <Grid item xs={6} sm={4} md={3} lg={2}>
        <Button onClick={() => open(key)}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12}>
              <InsertDriveFileOutlinedIcon color="primary" style={{ fontSize: 80 }} />
            </Grid>
            <Grid item xs={12}>
              <Typography >{text}</Typography>
            </Grid>
          </Grid>
        </Button>
      </Grid>
    );
  });
  return (
    <Page>
      <Layout fullWidth>
        <IconButton variant="contained" color="primary" onClick={() => { changeAnsicht(ansicht) }}>
          {ansicht === 0 &&
            <AppsIcon />
          }
          {ansicht === 1 &&
            <ListIcon />
          }
        </IconButton>
      </Layout>
      <Layout>
        {ansicht === 1 &&
          <Grid container>
            {displayJournalGrid}
          </Grid>}
        {ansicht !== 1 &&
          <TableContainer>
            <Table size="small">
            <TableBody>
              {displayJournalTable}
              </TableBody>
            </Table>
          </TableContainer>
        }
      </Layout>
      {showModal && <FullPageSpinner />}
    </Page>
  );
}
export default TimeAccount;
